import TabsContainer from './TabsContainer';
export default TabsContainer;

export { TabsContainer };
export Tabs from './Tabs';
export Tab from './Tab';
export MenuTab from './MenuTab';
export TabPanel from './TabPanel';



// WEBPACK FOOTER //
// ./src/js/Tabs/index.js